class IconService {
    constructor() {}
    getIcons() {
        return new Promise(function(resolve, reject) {
            let ls = localStorage.getItem('icons');
            if (ls === null || ls === '' || ls.split(',').length < 100) {
                console.log('icons from local CSS file');
                // const url = '/platform/aem/clientlib-site.min.css';
                // const url = '/platform/dotcms/css/style.min.css';
                const url = '/platform/icomoon/v2.4/style.css';
                // const url = '/platform/font-awesome/v5.13.1/all.css';
                let icons = [];
                fetch(url)
                    .then(resp => resp.text())
                    .then(function(data) {
                        const array = [...data.matchAll(/eq-icon-[^\s]+?(?=:before)/gm)];
                        // const array = [...data.matchAll(/fa-[^\s]+?(?=:before)/gm)];
                        let uniqueIcons = [];
                        const forLoop = async () => {
                            for (let i = 0; i < array.length; i++) {
                                let icon = array[i];
                                if (icon[0].indexOf(':') > -1) {
                                    icons.push(icon[0].split(':')[0]);
                                } else {
                                    icons.push(icon[0]);
                                }
                            }
                        };
                        forLoop()
                            .then(() => {
                                uniqueIcons = [...new Set(icons)];
                                uniqueIcons.sort();
                                console.log('get unique', icons.length, uniqueIcons.length);
                            })
                            .then(() => {
                                localStorage.setItem('icons', uniqueIcons);
                                resolve(uniqueIcons);
                            });
                    })
                    .catch(function(error) {
                        console.log(error);
                        reject(Error('error in IconService.getIcons()'));
                        // return icons;
                    });
            } else {
                let icons = localStorage.getItem('icons').split(',');
                console.log('icons from localStorage');
                resolve(icons);
            }
        });
    }
}
export default IconService;
